// Typelizer digest ea35db35f5e6034a58f64c2952ded9dc
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /c/:company_id/cash_accounts */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/cash_accounts', {}, options),
    method: 'post',
  }),

  /** PATCH /c/:company_id/cash_accounts/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/cash_accounts/:id', params, options),
    method: 'patch',
  }),
}
